module.exports = __webpack_public_path__ + "img/Map3.bf05282a.jpg";